// src/pages/EventDetail.jsx (fixed version)
import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useSearchParams, Link } from 'react-router-dom';
import { 
  Calendar, Clock, MapPin, Tv, ArrowLeft, Trophy, 
  Bell, AlertCircle, Globe, Zap, Timer, Radio, 
  Volume2, VolumeX, Maximize, Minimize, RefreshCw, 
  Wifi, WifiOff, Heart, Share2, ChevronDown, Star, 
  Play, Hourglass, ChevronRight
} from 'lucide-react';
import { matchesData } from '../data/matches';
import { getMatchStatus, getTimeRemaining, formatMatchTime, getUserTimezone } from '../utils/timeUtils';

// Data channel untuk setiap pertandingan
const channelData = {
  'premier-league-manchester-united-vs-liverpool': [
    { id: 'tnt1', name: 'TNT Sports 1', logo: 'TNT', quality: 'HD', url: 'https://starlive.pages.dev/play?id=tnt1', isFree: false },
    { id: 'tnt2', name: 'TNT Sports 2', logo: 'TNT', quality: 'HD', url: 'https://starlive.pages.dev/play?id=tnt2', isFree: false },
    { id: 'skys1', name: 'Sky Sports Main', logo: 'SKY', quality: '4K', url: 'https://starlive.pages.dev/play?id=skys1', isFree: false },
    { id: 'bein1', name: 'beIN Sports 1', logo: 'BEIN', quality: 'HD', url: 'https://starlive.pages.dev/play?id=bein1', isFree: true },
  ],
  
  'la-liga-real-madrid-vs-barcelona': [
    { id: 'movistar1', name: 'Movistar LaLiga', logo: 'MOV', quality: '4K', url: 'https://starlive.pages.dev/play?id=movistar1', isFree: false },
    { id: 'movistar2', name: 'Movistar+', logo: 'MOV', quality: 'HD', url: 'https://starlive.pages.dev/play?id=movistar2', isFree: false },
    { id: 'bein3', name: 'beIN Sports ES', logo: 'BEIN', quality: 'HD', url: 'https://starlive.pages.dev/play?id=bein3', isFree: true },
  ],
  
  'bundesliga-bayern-munich-vs-borussia-dortmund': [
    { id: 'skyde1', name: 'Sky Sport Bundesliga', logo: 'SKY', quality: '4K', url: 'https://starlive.pages.dev/play?id=skyde1', isFree: false },
    { id: 'skyde2', name: 'Sky Sport Mix', logo: 'SKY', quality: 'HD', url: 'https://starlive.pages.dev/play?id=skyde2', isFree: false },
    { id: 'dazn1', name: 'DAZN 1', logo: 'DAZN', quality: 'HD', url: 'https://starlive.pages.dev/play?id=dazn1', isFree: false },
    { id: 'ard', name: 'ARD', logo: 'ARD', quality: 'HD', url: 'https://starlive.pages.dev/play?id=ard', isFree: true },
  ],
  
  'serie-a-juventus-vs-ac-milan': [
    { id: 'skyit1', name: 'Sky Sport Serie A', logo: 'SKY', quality: '4K', url: 'https://starlive.pages.dev/play?id=skyit1', isFree: false },
    { id: 'skyit2', name: 'Sky Sport Calcio', logo: 'SKY', quality: 'HD', url: 'https://starlive.pages.dev/play?id=skyit2', isFree: false },
    { id: 'dazn2', name: 'DAZN IT', logo: 'DAZN', quality: 'HD', url: 'https://starlive.pages.dev/play?id=dazn2', isFree: false },
    { id: 'rai1', name: 'RAI 1', logo: 'RAI', quality: 'HD', url: 'https://starlive.pages.dev/play?id=rai1', isFree: true },
  ],
  
  'ligue-1-psg-vs-marseille': [
    { id: 'canal1', name: 'Canal+ Sport', logo: 'CANAL', quality: '4K', url: 'https://starlive.pages.dev/play?id=canal1', isFree: false },
    { id: 'canal2', name: 'Canal+ Foot', logo: 'CANAL', quality: 'HD', url: 'https://starlive.pages.dev/play?id=canal2', isFree: false },
    { id: 'bein4', name: 'beIN Sports FR', logo: 'BEIN', quality: 'HD', url: 'https://starlive.pages.dev/play?id=bein4', isFree: false },
    { id: 'tf1', name: 'TF1', logo: 'TF1', quality: 'HD', url: 'https://starlive.pages.dev/play?id=tf1', isFree: true },
  ],
  
  'premier-league-arsenal-vs-chelsea': [
    { id: 'tnt3', name: 'TNT Sports 3', logo: 'TNT', quality: 'HD', url: 'https://starlive.pages.dev/play?id=tnt3', isFree: false },
    { id: 'skys3', name: 'Sky Sports PL', logo: 'SKY', quality: '4K', url: 'https://starlive.pages.dev/play?id=skys3', isFree: false },
    { id: 'bein5', name: 'beIN Sports 2', logo: 'BEIN', quality: 'HD', url: 'https://starlive.pages.dev/play?id=bein5', isFree: true },
    { id: 'vidio2', name: 'Vidio Premier', logo: 'VID', quality: 'HD', url: 'https://starlive.pages.dev/play?id=vidio2', isFree: true },
  ],
  
  'default': [
    { id: 'channel1', name: 'Sports Channel 1', logo: 'SP1', quality: 'HD', url: 'https://starlive.pages.dev/play?id=channel1', isFree: true },
    { id: 'channel2', name: 'Sports Channel 2', logo: 'SP2', quality: 'HD', url: 'https://starlive.pages.dev/play?id=channel2', isFree: true },
    { id: 'channel3', name: 'Premium Sports', logo: 'PRE', quality: '4K', url: 'https://starlive.pages.dev/play?id=channel3', isFree: false },
    { id: 'channel4', name: 'Free Sports', logo: 'FREE', quality: 'SD', url: 'https://starlive.pages.dev/play?id=channel4', isFree: true },
  ]
};

const EventDetail = () => {
  const [searchParams] = useSearchParams();
  const eventId = searchParams.get('id');
  const [match, setMatch] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedChannel, setSelectedChannel] = useState(null);
  const [isMuted, setIsMuted] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [showChannelList, setShowChannelList] = useState(true);
  const [isFavorite, setIsFavorite] = useState(false);
  const [showShareMenu, setShowShareMenu] = useState(false);
  const [iframeError, setIframeError] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [iframeKey, setIframeKey] = useState(Date.now());
  const [timeRemaining, setTimeRemaining] = useState(null);
  const [matchStatus, setMatchStatus] = useState('upcoming');
  const [showCountdownDetail, setShowCountdownDetail] = useState(false);
  const [currentTimezone, setCurrentTimezone] = useState('');

  // Detect user timezone
  useEffect(() => {
    setCurrentTimezone(getUserTimezone());
  }, []);

  // Cari match berdasarkan ID
  useEffect(() => {
    if (eventId) {
      const foundMatch = matchesData.find(m => m.id === eventId);
      
      if (foundMatch) {
        setMatch(foundMatch);
        
        // Set default channel
        const matchKey = `${foundMatch.league.toLowerCase().replace(/\s+/g, '-')}-${foundMatch.homeTeam.name.toLowerCase()}-vs-${foundMatch.awayTeam.name.toLowerCase()}`;
        const channels = channelData[matchKey] || channelData.default;
        setSelectedChannel(channels[0]);
      }
      setLoading(false);
    }
  }, [eventId]);

  // Update status setiap detik
  useEffect(() => {
    if (match) {
      const updateStatus = () => {
        setMatchStatus(getMatchStatus(match));
      };
      
      updateStatus();
      const interval = setInterval(updateStatus, 1000);
      return () => clearInterval(interval);
    }
  }, [match]);

  // Countdown timer untuk upcoming
  useEffect(() => {
    if (match && matchStatus === 'upcoming') {
      const updateCountdown = () => {
        const remaining = getTimeRemaining(match);
        setTimeRemaining(remaining);
      };
      
      updateCountdown();
      const interval = setInterval(updateCountdown, 1000);
      return () => clearInterval(interval);
    }
  }, [match, matchStatus]);

  // Format waktu kickoff
  const kickoff = match ? formatMatchTime(match) : null;

  // Handle fullscreen
  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      setIsFullscreen(true);
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
        setIsFullscreen(false);
      }
    }
  };

  // Refresh iframe
  const refreshIframe = () => {
    setIsRefreshing(true);
    setIframeError(false);
    setIframeKey(Date.now());
    setTimeout(() => setIsRefreshing(false), 1000);
  };

  // Handle iframe error
  const handleIframeError = () => {
    setIframeError(true);
  };

  // Get channel list for current match
  const getChannelList = () => {
    if (!match) return channelData.default;
    
    const league = match.league.toLowerCase().replace(/\s+/g, '-');
    const homeTeam = match.homeTeam.name.toLowerCase().replace(/\s+/g, '-');
    const awayTeam = match.awayTeam.name.toLowerCase().replace(/\s+/g, '-');
    
    const matchKey = `${league}-${homeTeam}-vs-${awayTeam}`;
    
    return channelData[matchKey] || channelData.default;
  };

  const channels = getChannelList();
  const freeChannels = channels.filter(c => c.isFree);
  const premiumChannels = channels.filter(c => !c.isFree);

  // Format tanggal
  const formatDate = (dateISO) => {
    return new Date(dateISO).toLocaleDateString('id-ID', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const statusColors = {
    live: 'from-red-500 to-red-600',
    finished: 'from-gray-500 to-gray-600',
    upcoming: 'from-football-green-500 to-football-green-600'
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-900 via-football-green-900 to-gray-900 flex items-center justify-center">
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
          className="w-16 h-16 border-4 border-football-green-500 border-t-transparent rounded-full"
        />
      </div>
    );
  }

  if (!match) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-900 via-football-green-900 to-gray-900">
        <div className="container mx-auto px-4 py-8">
          <Link
            to="/"
            className="inline-flex items-center space-x-2 text-white/80 hover:text-white mb-8"
          >
            <ArrowLeft className="w-5 h-5" />
            <span>Kembali ke Jadwal</span>
          </Link>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="glass-card p-12 text-center"
          >
            <AlertCircle className="w-20 h-20 text-white/50 mx-auto mb-4" />
            <h1 className="text-2xl font-bold text-white mb-2">Pertandingan Tidak Ditemukan</h1>
            <p className="text-white/70">Maaf, pertandingan yang Anda cari tidak tersedia.</p>
            <Link
              to="/"
              className="inline-block mt-6 px-6 py-3 bg-football-green-500 text-white rounded-xl hover:bg-football-green-600 transition-colors"
            >
              Lihat Jadwal Lainnya
            </Link>
          </motion.div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-football-green-900 to-gray-900">
      {/* Animated Background */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 w-72 h-72 bg-football-green-500 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-float" />
        <div className="absolute top-40 right-10 w-72 h-72 bg-blue-500 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-float animation-delay-2000" />
        <div className="absolute bottom-20 left-1/2 w-72 h-72 bg-purple-500 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-float animation-delay-4000" />
      </div>

      <div className="relative z-10 container mx-auto px-4 py-8">
        {/* Header with Navigation */}
        <div className="flex items-center justify-between mb-6">
          <Link
            to="/"
            className="inline-flex items-center space-x-2 text-white/80 hover:text-white group"
          >
            <motion.div
              whileHover={{ x: -5 }}
              transition={{ type: "spring", stiffness: 400 }}
            >
              <ArrowLeft className="w-5 h-5" />
            </motion.div>
            <span>Kembali ke Jadwal</span>
          </Link>

          <div className="flex items-center space-x-3">
            <motion.button
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              onClick={() => setIsFavorite(!isFavorite)}
              className={`p-2 rounded-full transition-colors ${
                isFavorite ? 'bg-red-500/20 text-red-500' : 'bg-white/10 text-white/80 hover:bg-white/20'
              }`}
            >
              <Heart className={`w-5 h-5 ${isFavorite ? 'fill-current' : ''}`} />
            </motion.button>
            
            <motion.button
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              onClick={() => setShowShareMenu(!showShareMenu)}
              className="p-2 rounded-full bg-white/10 text-white/80 hover:bg-white/20 relative"
            >
              <Share2 className="w-5 h-5" />
              
              <AnimatePresence>
                {showShareMenu && (
                  <motion.div
                    initial={{ opacity: 0, y: 10, scale: 0.9 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    exit={{ opacity: 0, y: 10, scale: 0.9 }}
                    className="absolute right-0 mt-2 w-48 glass-card p-2 z-50"
                  >
                    <button className="w-full text-left px-4 py-2 text-white/80 hover:text-white hover:bg-white/10 rounded-lg transition-colors">
                      Copy Link
                    </button>
                    <button className="w-full text-left px-4 py-2 text-white/80 hover:text-white hover:bg-white/10 rounded-lg transition-colors">
                      Share ke WhatsApp
                    </button>
                    <button className="w-full text-left px-4 py-2 text-white/80 hover:text-white hover:bg-white/10 rounded-lg transition-colors">
                      Share ke Twitter
                    </button>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.button>
          </div>
        </div>

        {/* Main Content */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Video Player Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="lg:col-span-2 space-y-4"
          >
            {/* Video Player */}
            <div className="glass-card p-4">
              <div className="relative aspect-video bg-black rounded-xl overflow-hidden group">
                {selectedChannel ? (
                  <>
                    <iframe
                      key={iframeKey}
                      src={selectedChannel.url}
                      className="w-full h-full"
                      allowFullScreen
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      onError={handleIframeError}
                    />
                    
                    {/* Video Controls Overlay */}
                    <motion.div 
                      initial={{ opacity: 0 }}
                      whileHover={{ opacity: 1 }}
                      className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 to-transparent p-4 opacity-0 group-hover:opacity-100 transition-opacity"
                    >
                      <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-3">
                          <motion.button
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.9 }}
                            onClick={() => setIsMuted(!isMuted)}
                            className="p-2 rounded-full bg-white/20 hover:bg-white/30"
                          >
                            {isMuted ? <VolumeX className="w-4 h-4" /> : <Volume2 className="w-4 h-4" />}
                          </motion.button>
                          
                          <motion.button
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.9 }}
                            onClick={refreshIframe}
                            className="p-2 rounded-full bg-white/20 hover:bg-white/30"
                            disabled={isRefreshing}
                          >
                            <RefreshCw className={`w-4 h-4 ${isRefreshing ? 'animate-spin' : ''}`} />
                          </motion.button>
                        </div>
                        
                        <div className="flex items-center space-x-3">
                          <span className="text-xs bg-black/50 px-2 py-1 rounded">
                            {selectedChannel.quality}
                          </span>
                          
                          <motion.button
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.9 }}
                            onClick={toggleFullscreen}
                            className="p-2 rounded-full bg-white/20 hover:bg-white/30"
                          >
                            {isFullscreen ? <Minimize className="w-4 h-4" /> : <Maximize className="w-4 h-4" />}
                          </motion.button>
                        </div>
                      </div>
                    </motion.div>

                    {/* Connection Status */}
                    {iframeError && (
                      <motion.div
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        className="absolute inset-0 flex flex-col items-center justify-center bg-black/80"
                      >
                        <WifiOff className="w-16 h-16 text-red-500 mb-4" />
                        <p className="text-white text-lg mb-2">Koneksi Terputus</p>
                        <p className="text-white/60 text-sm mb-4">Periksa koneksi internet Anda</p>
                        <motion.button
                          whileHover={{ scale: 1.05 }}
                          whileTap={{ scale: 0.95 }}
                          onClick={refreshIframe}
                          className="px-6 py-3 bg-football-green-500 text-white rounded-xl flex items-center space-x-2"
                        >
                          <RefreshCw className="w-4 h-4" />
                          <span>Coba Lagi</span>
                        </motion.button>
                      </motion.div>
                    )}
                  </>
                ) : (
                  <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-gray-800 to-gray-900">
                    <Radio className="w-16 h-16 text-white/30" />
                    <p className="text-white/50 ml-4">Pilih channel untuk mulai menonton</p>
                  </div>
                )}
              </div>

              {/* Now Playing Info */}
              {selectedChannel && (
                <motion.div
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  className="mt-4 flex items-center justify-between"
                >
                  <div className="flex items-center space-x-3">
                    <div className="w-10 h-10 rounded-full bg-football-green-500/20 flex items-center justify-center">
                      <Tv className="w-5 h-5 text-football-green-400" />
                    </div>
                    <div>
                      <p className="text-sm text-white/60">Sedang Memutar</p>
                      <p className="text-white font-semibold">{selectedChannel.name}</p>
                    </div>
                  </div>
                  {selectedChannel.isFree ? (
                    <span className="px-3 py-1 bg-green-500/20 text-green-400 rounded-full text-sm font-medium">
                      Free
                    </span>
                  ) : (
                    <span className="px-3 py-1 bg-yellow-500/20 text-yellow-400 rounded-full text-sm font-medium">
                      Premium
                    </span>
                  )}
                </motion.div>
              )}
            </div>

            {/* Match Info Summary - FIXED: menggunakan matchStatus dan dateISO */}
            <div className="glass-card p-4">
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center space-x-2">
                  <Trophy className="w-5 h-5 text-yellow-400" />
                  <span className="font-semibold text-white">Informasi Pertandingan</span>
                </div>
                <span className={`px-3 py-1 bg-gradient-to-r ${statusColors[matchStatus]} text-white text-xs font-bold rounded-full`}>
                  {matchStatus === 'live' && 'LIVE'}
                  {matchStatus === 'finished' && 'FT'}
                  {matchStatus === 'upcoming' && 'UPCOMING'}
                </span>
              </div>
              
              <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                <div className="bg-white/5 rounded-lg p-2">
                  <Calendar className="w-4 h-4 text-football-green-400 mb-1" />
                  <p className="text-white/60 text-xs">Tanggal</p>
                  <p className="text-white text-sm font-medium">{kickoff?.localDate}</p>
                </div>
                <div className="bg-white/5 rounded-lg p-2">
                  <Clock className="w-4 h-4 text-football-green-400 mb-1" />
                  <p className="text-white/60 text-xs">Waktu</p>
                  <p className="text-white text-sm font-medium">{kickoff?.localTime}</p>
                </div>
                <div className="bg-white/5 rounded-lg p-2">
                  <MapPin className="w-4 h-4 text-football-green-400 mb-1" />
                  <p className="text-white/60 text-xs">Stadion</p>
                  <p className="text-white text-sm font-medium truncate">{match.venue}</p>
                </div>
                <div className="bg-white/5 rounded-lg p-2">
                  <Globe className="w-4 h-4 text-football-green-400 mb-1" />
                  <p className="text-white/60 text-xs">Liga</p>
                  <p className="text-white text-sm font-medium">{match.league}</p>
                </div>
              </div>

              {/* Hasil akhir untuk finished match */}
              {matchStatus === 'finished' && (
                <div className="mt-3 text-center p-3 bg-white/5 rounded-lg">
                  <p className="text-white/60 text-xs mb-1">Hasil Akhir</p>
                  <p className="text-3xl font-bold text-white">
                    {match.score.home} - {match.score.away}
                  </p>
                </div>
              )}
            </div>
          </motion.div>

          {/* Channel List Section */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.2 }}
            className="space-y-4"
          >
            {/* Channel List Header */}
            <div className="glass-card p-4">
              <div 
                className="flex items-center justify-between cursor-pointer"
                onClick={() => setShowChannelList(!showChannelList)}
              >
                <div className="flex items-center space-x-2">
                  <Radio className="w-5 h-5 text-football-green-400" />
                  <h2 className="text-lg font-semibold text-white">Daftar Channel</h2>
                  <span className="text-xs bg-football-green-500/20 text-football-green-400 px-2 py-1 rounded-full">
                    {channels.length}
                  </span>
                </div>
                <motion.div
                  animate={{ rotate: showChannelList ? 180 : 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <ChevronDown className="w-5 h-5 text-white/60" />
                </motion.div>
              </div>

              <AnimatePresence>
                {showChannelList && (
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: 'auto' }}
                    exit={{ opacity: 0, height: 0 }}
                    className="mt-4 space-y-4"
                  >
                    <input
                      type="text"
                      placeholder="Cari channel..."
                      className="w-full px-4 py-2 bg-white/5 border border-white/10 rounded-lg text-white placeholder-white/40 focus:outline-none focus:border-football-green-500"
                    />

                    {/* Free Channels */}
                    {freeChannels.length > 0 && (
                      <div>
                        <h3 className="text-sm font-medium text-white/60 mb-2 flex items-center">
                          <Wifi className="w-4 h-4 mr-1 text-green-400" />
                          Channel Gratis
                        </h3>
                        <div className="space-y-2">
                          {freeChannels.map((channel) => (
                            <motion.button
                              key={channel.id}
                              whileHover={{ scale: 1.02, x: 5 }}
                              whileTap={{ scale: 0.98 }}
                              onClick={() => setSelectedChannel(channel)}
                              className={`w-full p-3 rounded-xl flex items-center space-x-3 transition-all ${
                                selectedChannel?.id === channel.id
                                  ? 'bg-gradient-to-r from-football-green-500 to-football-green-600'
                                  : 'bg-white/5 hover:bg-white/10'
                              }`}
                            >
                              <div className="w-10 h-10 rounded-full bg-black/30 flex items-center justify-center font-bold text-white">
                                {channel.logo}
                              </div>
                              <div className="flex-1 text-left">
                                <p className="text-white font-medium text-sm">{channel.name}</p>
                                <div className="flex items-center space-x-2 mt-1">
                                  <span className="text-xs text-white/60">{channel.quality}</span>
                                  <span className="text-xs bg-green-500/20 text-green-400 px-1.5 rounded">
                                    Free
                                  </span>
                                </div>
                              </div>
                            </motion.button>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* Premium Channels */}
                    {premiumChannels.length > 0 && (
                      <div>
                        <h3 className="text-sm font-medium text-white/60 mb-2 flex items-center">
                          <Star className="w-4 h-4 mr-1 text-yellow-400" />
                          Channel Premium
                        </h3>
                        <div className="space-y-2">
                          {premiumChannels.map((channel) => (
                            <motion.button
                              key={channel.id}
                              whileHover={{ scale: 1.02, x: 5 }}
                              whileTap={{ scale: 0.98 }}
                              onClick={() => setSelectedChannel(channel)}
                              className={`w-full p-3 rounded-xl flex items-center space-x-3 transition-all ${
                                selectedChannel?.id === channel.id
                                  ? 'bg-gradient-to-r from-yellow-500 to-yellow-600'
                                  : 'bg-white/5 hover:bg-white/10'
                              }`}
                            >
                              <div className="w-10 h-10 rounded-full bg-black/30 flex items-center justify-center font-bold text-white">
                                {channel.logo}
                              </div>
                              <div className="flex-1 text-left">
                                <p className="text-white font-medium text-sm">{channel.name}</p>
                                <div className="flex items-center space-x-2 mt-1">
                                  <span className="text-xs text-white/60">{channel.quality}</span>
                                  <span className="text-xs bg-yellow-500/20 text-yellow-400 px-1.5 rounded">
                                    Premium
                                  </span>
                                </div>
                              </div>
                            </motion.button>
                          ))}
                        </div>
                      </div>
                    )}
                  </motion.div>
                )}
              </AnimatePresence>
            </div>

            {/* Match Information / Countdown - FIXED: menggunakan matchStatus */}
            <div className="glass-card p-4">
              <h3 className="text-sm font-medium text-white/60 mb-3 flex items-center">
                {matchStatus === 'upcoming' && (
                  <>
                    <Hourglass className="w-4 h-4 mr-2 text-football-green-400" />
                    Countdown Menuju Pertandingan
                  </>
                )}
                {matchStatus === 'live' && (
                  <>
                    <Zap className="w-4 h-4 mr-2 text-red-400" />
                    Status Pertandingan
                  </>
                )}
                {matchStatus === 'finished' && (
                  <>
                    <Trophy className="w-4 h-4 mr-2 text-yellow-400" />
                    Hasil Akhir
                  </>
                )}
              </h3>
              
              {matchStatus === 'upcoming' && timeRemaining && !timeRemaining.isLive && (
                <div>
                  {/* Enhanced Countdown */}
                  <div 
                    className="relative overflow-hidden rounded-xl p-4 cursor-pointer bg-gradient-to-br from-football-green-900/50 to-blue-900/50"
                    onClick={() => setShowCountdownDetail(!showCountdownDetail)}
                  >
                    <motion.div
                      className="absolute inset-0 bg-gradient-to-r from-football-green-600/20 via-blue-600/20 to-purple-600/20"
                      animate={{
                        backgroundPosition: ['0% 50%', '100% 50%', '0% 50%'],
                      }}
                      transition={{
                        duration: 5,
                        repeat: Infinity,
                        ease: "linear"
                      }}
                      style={{
                        backgroundSize: '200% 200%',
                      }}
                    />
                    
                    <div className="relative z-10">
                      <div className="grid grid-cols-4 gap-2 text-center">
                        {timeRemaining.days > 0 && (
                          <div>
                            <motion.div 
                              className="text-3xl font-bold text-white"
                              animate={{ scale: [1, 1.05, 1] }}
                              transition={{ duration: 2, repeat: Infinity }}
                            >
                              {timeRemaining.days}
                            </motion.div>
                            <div className="text-xs text-white/60">Hari</div>
                          </div>
                        )}
                        <div>
                          <motion.div 
                            className="text-3xl font-bold text-white"
                            animate={{ 
                              scale: timeRemaining.hours < 1 ? [1, 1.1, 1] : 1,
                              color: timeRemaining.hours < 1 ? '#fbbf24' : '#ffffff'
                            }}
                            transition={{ duration: 1, repeat: timeRemaining.hours < 1 ? Infinity : 0 }}
                          >
                            {String(timeRemaining.hours).padStart(2, '0')}
                          </motion.div>
                          <div className="text-xs text-white/60">Jam</div>
                        </div>
                        <div>
                          <motion.div 
                            className="text-3xl font-bold text-white"
                            animate={{ 
                              scale: timeRemaining.minutes < 5 ? [1, 1.1, 1] : 1,
                              color: timeRemaining.minutes < 5 ? '#f97316' : '#ffffff'
                            }}
                            transition={{ duration: 1, repeat: timeRemaining.minutes < 5 ? Infinity : 0 }}
                          >
                            {String(timeRemaining.minutes).padStart(2, '0')}
                          </motion.div>
                          <div className="text-xs text-white/60">Menit</div>
                        </div>
                        <div>
                          <motion.div 
                            className="text-3xl font-bold text-white"
                            animate={{ 
                              scale: [1, 1.2, 1],
                              color: timeRemaining.seconds < 10 ? '#ef4444' : '#ffffff'
                            }}
                            transition={{ duration: 1, repeat: Infinity }}
                          >
                            {String(timeRemaining.seconds).padStart(2, '0')}
                          </motion.div>
                          <div className="text-xs text-white/60">Detik</div>
                        </div>
                      </div>

                      <div className="flex items-center justify-between mt-2">
                        <span className="text-xs text-white/40">
                          {kickoff?.localDate} • {kickoff?.localTime}
                        </span>
                        <motion.div
                          animate={{ rotate: showCountdownDetail ? 180 : 0 }}
                          transition={{ duration: 0.3 }}
                        >
                          <ChevronDown className="w-4 h-4 text-white/60" />
                        </motion.div>
                      </div>

                      <AnimatePresence>
                        {showCountdownDetail && (
                          <motion.div
                            initial={{ opacity: 0, height: 0 }}
                            animate={{ opacity: 1, height: 'auto' }}
                            exit={{ opacity: 0, height: 0 }}
                            className="mt-3 pt-3 border-t border-white/20"
                          >
                            <div className="grid grid-cols-2 gap-2 text-xs">
                              <div className="bg-white/5 rounded-lg p-2">
                                <span className="text-white/60 block">Stadion</span>
                                <span className="text-white font-medium">{match.venue}</span>
                              </div>
                              <div className="bg-white/5 rounded-lg p-2">
                                <span className="text-white/60 block">Channel</span>
                                <span className="text-white font-medium">{match.tvChannel}</span>
                              </div>
                            </div>
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </div>
                  </div>

                  {/* Reminder Button */}
                  <Link to={`/event/live?id=${match.id}`}>
                    <motion.button
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                      className="w-full mt-3 px-4 py-3 bg-gradient-to-r from-football-green-500 to-football-green-600 hover:from-football-green-600 hover:to-football-green-700 text-white rounded-xl font-semibold transition-all duration-300 flex items-center justify-center space-x-2 shadow-lg shadow-football-green-500/30"
                    >
                      <Bell className="w-4 h-4" />
                      <span>Ingatkan Saya</span>
                    </motion.button>
                  </Link>
                </div>
              )}

              {matchStatus === 'live' && (
                <div className="text-center py-6">
                  <motion.div
                    animate={{ scale: [1, 1.1, 1] }}
                    transition={{ duration: 2, repeat: Infinity }}
                    className="inline-block"
                  >
                    <div className="relative">
                      <span className="text-red-500 font-bold text-2xl flex items-center justify-center">
                        <span className="w-3 h-3 bg-red-500 rounded-full mr-2 animate-pulse" />
                        LIVE
                      </span>
                    </div>
                  </motion.div>
                  <p className="text-white/60 mt-3">Pertandingan sedang berlangsung</p>
                  
                  {/* Watch Live Button */}
                  <Link to={`/event/live?id=${match.id}`}>
                    <motion.button
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                      className="w-full mt-4 px-4 py-3 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white rounded-xl font-semibold transition-all duration-300 flex items-center justify-center space-x-2 shadow-lg shadow-red-500/30"
                    >
                      <Play className="w-4 h-4" />
                      <span>Tonton Live</span>
                    </motion.button>
                  </Link>
                </div>
              )}

              {matchStatus === 'finished' && (
                <div className="text-center py-4">
                  <div className="text-5xl font-bold text-white mb-3">
                    {match.score.home} - {match.score.away}
                  </div>
                  <p className="text-white/60">Pertandingan Selesai</p>
                  
                  <Link to="/">
                    <motion.button
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                      className="w-full mt-4 px-4 py-3 bg-gradient-to-r from-gray-600 to-gray-700 hover:from-gray-700 hover:to-gray-800 text-white rounded-xl font-semibold transition-all duration-300 flex items-center justify-center space-x-2"
                    >
                      <Calendar className="w-4 h-4" />
                      <span>Lihat Jadwal Lainnya</span>
                    </motion.button>
                  </Link>
                </div>
              )}
            </div>

            {/* Timezone Info */}
            <div className="glass-card p-3">
              <div className="flex items-center justify-between text-xs text-white/40">
                <span>Zona Waktu Anda:</span>
                <span className="font-medium text-white/60">{currentTimezone}</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default EventDetail;